import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ScheduleService } from '../../schedule.service';
import { RouteTripActions } from './route-trip.actions';

@Injectable()
export class RouteTripEpics implements RidangoEpic {
    constructor(private actions: RouteTripActions, private service: ScheduleService) { }

    register() {
        return [ this.fetchRouteTrip ];
    }

    fetchRouteTrip = (action$: ActionsObservable<any>) =>
        action$.ofType(RouteTripActions.FETCH_ROUTE_TRIP).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchRouteTrip(action.payload).pipe(
                    map((response) => this.actions.fetchRouteTripSuccess({stops: response})),
                    catchError(() => of(this.actions.fetchRouteTripFail()))
                );
            })
        )
}
